import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../api';

const Apply = () => {
    const { campus_slug } = useParams();
    const [applyData, setApplyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get(`/api/campus/${campus_slug}/apply`);
                setApplyData(response.data.apply_section);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading || error || applyData.length === 0) {
        return <></>;
    }

    return (
        <div className="apply-area py-3">
            <div className="container">
                <div className="row align-items-center wow slideInUp">
                    <div className={`col-lg-6 col-md-6 col-12 wow slideInUp ${applyData.image_position === 'right' ? 'order-md-2' : ''}`}>
                        <div className="apply-image">
                            <div className="image">
                                <img 
                                    src={`${process.env.REACT_APP_API_URL}/public/${applyData.image}`} 
                                    alt="apply-bg"
                                />
                            </div>
                            {[...Array(6)].map((_, i) => (
                                <span key={i} className={`bubble bubble-${i + 1}`}></span>
                            ))}
                        </div>
                    </div>
                    <div className={`col-lg-6 col-md-6 col-12 wow slideInUp ${applyData.image_position === 'right' ? 'order-md-1' : ''}`}>
                        <div className="apply-content">
                            <div className="title text-center wow fadeIn" data-wow-duration="2s">
                                <h2>{applyData.title}</h2>
                            </div>
                            <div className="apply-roadmap">
                                {applyData.steps.map((step, index) => (
                                    <div key={step.number} className={`apply-content-card d-flex gap-3 wow fadeIn ${index === applyData.steps.length -1 ? 'bg-white' : ''}`} 
                                         data-wow-duration="2s" data-wow-delay={`${0.2 * index}s`}>
                                        <div className="roadmap-step d-flex flex-column align-items-center">
                                            <div className="step-number-icon d-flex align-items-center">
                                                <div className="step-number">{step.number}</div>
                                            </div>
                                            {index < applyData.steps.length - 1 && <div className="roadmap-line"></div>}
                                        </div>
                                        <div className="content">
                                            <h3>{step.title}</h3>
                                            {step.text && (
                                            <p>➡️ {step.text}</p>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <ul className="list-unstyled ps-5 mb-0 apply-btn wow fadeIn" data-wow-duration="2s">
                                <li className="d-inline-block">
                                    <a className="text-decoration-none default-btn" href="https://admission.care.edu.in/kelambakkam" target="_blank" rel="noreferrer">
                                        Apply Now <i className="fa fa-arrow-right color-white"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Apply;